<template>
  <b-modal
    v-model="visible"
    :title="$t('common.notification')"
    header-bg-variant="dark"
    header-text-variant="light"
    body-bg-variant="dark"
    body-text-variant="light"
    footer-bg-variant="dark"
    footer-text-variant="light"
    ok-only
    hideHeaderClose
    @ok="clickOk"
  >
    <p>{{ $t('notification.subscribed', { tzName }) }}</p>
    <p>
      {{ $t('notification.additionalInfo') }}
    </p>
    <b-button
      class="my-3"
      variant="primary"
      @click="$emit('show-install-guide')"
    >
      {{ $t('installApp.howToInstall') }}
    </b-button>
    <b-form-checkbox
      class="checkbox mt-1"
      v-model="neverShowAgain"
    >
      {{ $t('common.neverShowAgain') }}
    </b-form-checkbox>
  </b-modal>
</template>

<script>
import { tzData } from '@/utils/tz_data'

export default {
  name: 'NotificationTipModal',

  data() {
    return {
      visible: false,
      neverShowAgain: false,
    }
  },

  emits: ['show-install-guide'],

  props: {
    language: {
      type: String,
      required: true
    },

    tzId: {
      type: String
    },
  },

  computed: {

    tzName () {
      const tzItem = tzData.find(x => x['id'] === this.tzId);
      if (!tzItem) {
        return this.tzId;
      }
      return tzItem['name'][this.language];
    },
  },

  methods: {
    show () {
      this.visible = true;
    },

    hide () {
      this.visible = false;
    },

    clickOk () {
      if (this.neverShowAgain) {
        localStorage.setItem('do_not_show_notification_modal', true);
      }
    },
  },
}
</script>
<style>
.checkbox input {
  margin: 3px
}
</style>